import React from 'react';
import { Component } from 'react';
import UapHeader from './UapHeader';
import AppHeaderStyles from './AppHeader.module.css';

class AppHeader extends Component {
  // TS and eslint throw conflicting errors here.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    title: undefined,
  };

  menuToggleButton;

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  componentDidMount() {
    // Set up an event listener for the menu toggle button so that when shift-tabbing off of it,
    // the menu will automatically close (now that the user is no longer interacting with the menu).
    this.menuToggleButton = document.querySelector(`.${AppHeaderStyles.mainNavMenuToggle}`);
    if (this.menuToggleButton !== null) {
      this.menuToggleButton.addEventListener('keydown', this.handleToggleShiftTab);
      this.handleToggleShiftTab.bind(this);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { menuOpen } = this.state;
    if (!prevState.menuOpen && menuOpen) {
      // Menu was just opened
      window.addEventListener('keydown', this.closeOnEvent);
      window.addEventListener('click', this.closeOnEvent);
    } else if (prevState.menuOpen && !menuOpen) {
      // Menu was just closed
      window.removeEventListener('keydown', this.closeOnEvent);
      window.removeEventListener('click', this.closeOnEvent);
    }
  }

  componentWillUnmount() {
    if (this.menuToggleButton !== null && this.menuToggleButton !== undefined) {
      this.menuToggleButton.removeEventListener('keydown', this.handleToggleShiftTab);
    }
  }

  closeOnEvent = (event) => {
    const clickedItemInMenu = (clickedItem) =>
      clickedItem.closest(`.${AppHeaderStyles.menu}, .${AppHeaderStyles.mainNavIcon}, #hamburgerMenuHeader`) !== null;

    const { menuOpen } = this.state;
    if (menuOpen) {
      if (event instanceof MouseEvent && event.target instanceof Element) {
        if (!clickedItemInMenu(event.target)) {
          this.closeMenu();
        }
      } else if (event instanceof KeyboardEvent) {
        if (event.key.toLocaleLowerCase() === 'escape' || event.key.toLocaleLowerCase() === 'esc') {
          this.closeMenu();
        }
      }
    }
  };

  closeMenu = () => {
    const { menuOpen } = this.state;
    if (menuOpen) {
      this.setState({
        menuOpen: false,
      });
    }
  };

  handleToggleShiftTab = (event) => {
    if (event.key.toLocaleLowerCase() === 'tab' && event.shiftKey) {
      this.closeMenu();
    }
  };

  toggleMenu = () => {
    this.setState((state) => ({
      menuOpen: !state.menuOpen,
    }));
  };

  render() {
    const { menu, userName, title } = this.props;
    const { menuOpen } = this.state;
    return (
      <UapHeader
        headerMenus={menu}
        onToggleShowMenu={this.toggleMenu}
        showMenu={menuOpen}
        username={userName}
        title={title}
      />
    );
  }
}

export default AppHeader;
